import React, { useEffect } from 'react'
import { getContentfulImageURL } from '../../../lib/helpers';
import { Link } from 'gatsby';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../lib/context';
import { AnimatePresence, motion } from 'framer-motion'
import RightArrow from '../Icons/RightArrow';
import LeftArrow from '../Icons/LeftArrow';
import CategoryTag from '../General/CategoryTag';


const TimedCarousel = observer(({data}) => {
    const {uiStore: {updateCarouselTimer, stopCarouselTimer, indexv2__timerCarouselActiveSlideIndex}} = useStore();
    const article = data[indexv2__timerCarouselActiveSlideIndex];
    const imageSrc = getContentfulImageURL(article?.listViewImage?.file?.url, 1200, 90);
    const title = article?.title;



    useEffect(() => {
        updateCarouselTimer()

        return () => {
            stopCarouselTimer()
            // clearTimeout(timeout)
        }
    }, [])

    const season = article.sys?.contentType?.sys?.id === "articleV2" ? "Season 2" : "Season 1"

    return (
        <div className='timed-carousel'>
            
            
                <div className='image-card'>
                    <CarouselControls/>
                        <div className="article-details">
                            <CategoryTag>{article.category}</CategoryTag>
                            <CategoryTag>{season}</CategoryTag>
                        </div>
                        <Link to={`/${article.category.toLowerCase()}/${article.slug}`}>
                            <AnimatePresence>

                                <motion.div key={imageSrc}  animate={{opacity: 1 }} initial={{opacity: 0}} exit={{opacity: 0}}>
                                    <img src={imageSrc} alt="" />
                                </motion.div>
                            </AnimatePresence>
                        </Link>
                    <TimedCarouselTimer/>
                </div>
            
            <motion.div key={`car-art-t${title}`} animate={{ y: 0, opacity: 1 }} initial={{y: 20, opacity: 0}} transition={{duration: .3}}>
                <h4  className='elizeth article-title'>{title}</h4>
            </motion.div>
            <style jsx>{`
                .timed-carousel {
                    padding-top: 150px;
                    // position: relative;
                }
                .image-card {
                    width: 100%;
                    padding-bottom: 105%;
                    position: relative;
                    border-radius: 15px;
                    overflow: hidden;
                    background: #f4f4f4;
                }
                .article-details {
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                    z-index: 1;
                    padding: 20px;
                    margin-bottom: 20px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-gap: 10px;
                    
                }                    

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .article-title {
                    font-size: 32px;
                    padding: 12px 20px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .timed-carousel {
                        padding-top: 40px;
                    }
                    .article-title {
                        font-size: 22px;
                    }
                }
            `}</style>
        </div>

    )
})

const TimedCarouselTimer = observer(() => {
    const {uiStore:{indexv2__timerCarouselPct, indexv2__timerCarouselActiveSlideIndex: slideIdx}} = useStore();
    const transform = `translateX(-${100 - indexv2__timerCarouselPct}%)`
    const completeTransform = `translateX(0%)`;
    const nonStartedTransform = `translateX(-100%)`;
    
    return (
        <div className='timer'>

            <div className="timer-item">
                <div style={{transform: slideIdx === 0 ? transform : completeTransform}} className="timer-item__inner"></div>
            </div>

            <div className="timer-item">
            <div style={{transform: slideIdx === 1 ? transform : slideIdx === 0 ? nonStartedTransform : completeTransform}} className="timer-item__inner"></div>
            </div>

            <div className="timer-item">
            <div style={{transform: slideIdx === 2 ? transform : nonStartedTransform}} className="timer-item__inner"></div>
            </div>

            <style jsx>{`
                .timer {
                    display: grid;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    grid-template-columns: repeat(3, 1fr);
                    grid-gap: 5px;
                    padding: 12px;
                }

                .timer-item {
                    height: 6px;
                    width: 100%;
                    border-radius: 10px;
                    background: rgba(255, 255, 255, 0.6);
                    overflow: hidden;
                }

                .timer-item__inner {
                    height: 100%;
                    width 100%;
                    border-radius: 10px;
                    background: white;
                    transform: translateX(-50%);
                }
            `}</style>
        </div>
    )
})

const CarouselControls = () => {
    const {uiStore: {incrementCarouselSlide, decrementCarouselSlide}} = useStore();
    return (
        <div className='carousel-controls'>
            <LeftArrow onClick={decrementCarouselSlide}/>
            <RightArrow onClick={incrementCarouselSlide}/>
            <style jsx>{`
                .carousel-controls {
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    left: 0;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 20px;
                    transform: translateY(-50%);

                }


                .carousel-controls :global(svg) {
                    height: 32px;
                    cursor: pointer;
                }

                .carousel-controls :global(svg circle) {
                   transition: opacity .2s ease;
                }

                .carousel-controls :global(svg:hover circle) {
                    opacity: 1;
                }

            `}</style>
        </div>
    )
}

export default TimedCarousel